// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Drag and Drop Styles */
.content-block-content {
  position: relative;
  min-height: 60px;
  margin-bottom: 16px;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 8px;
  background: #fff;
  transition: all 0.2s ease;
}

.content-block-content.dragging {
  opacity: 0.6;
  transform: scale(0.98);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 1000;
  position: relative;
}

.drag-handle {
  position: absolute;
  top: 8px;
  left: -18px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: move;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #6c757d;
  opacity: 0;
  transition: all 0.2s ease;
  width: 32px;
  height: 32px;
}

.drag-handle:hover {
  background: var(--admin-color);
  color: white;
  border-color: var(--admin-color);
}

.content-block-content:hover .drag-handle {
  opacity: 1;
}

.content-block-content.drag-over {
  background-color: #f8f9fa;
  border: 2px dashed var(--admin-color);
  border-radius: 8px;
  transform: scale(1);
}

.content-block-content:hover {
  border: 1px solid #dee2e6;
  background: #fafafa;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .drag-handle {
    top: 5px;
    left: 5px;
    padding: 3px 6px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Blog/BlogEdit/DragDrop.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;EACvC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["/* Drag and Drop Styles */\n.content-block-content {\n  position: relative;\n  min-height: 60px;\n  margin-bottom: 16px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  padding: 8px;\n  background: #fff;\n  transition: all 0.2s ease;\n}\n\n.content-block-content.dragging {\n  opacity: 0.6;\n  transform: scale(0.98);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  z-index: 1000;\n  position: relative;\n}\n\n.drag-handle {\n  position: absolute;\n  top: 8px;\n  left: -18px;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 4px 8px;\n  cursor: move;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  color: #6c757d;\n  opacity: 0;\n  transition: all 0.2s ease;\n  width: 32px;\n  height: 32px;\n}\n\n.drag-handle:hover {\n  background: var(--admin-color);\n  color: white;\n  border-color: var(--admin-color);\n}\n\n.content-block-content:hover .drag-handle {\n  opacity: 1;\n}\n\n.content-block-content.drag-over {\n  background-color: #f8f9fa;\n  border: 2px dashed var(--admin-color);\n  border-radius: 8px;\n  transform: scale(1);\n}\n\n.content-block-content:hover {\n  border: 1px solid #dee2e6;\n  background: #fafafa;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .drag-handle {\n    top: 5px;\n    left: 5px;\n    padding: 3px 6px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
